const messages = {
  setup: {
    fr: 'Le paiement n’est pas encore configuré sur le serveur. Les variables Stripe doivent être renseignées par l’administrateur.',
    en: 'Payments are not configured on the server yet. An administrator must configure the Stripe variables.',
    es: 'El pago aún no está configurado en el servidor. El administrador debe configurar las variables de Stripe.',
    ar: 'الدفع غير مهيأ على الخادم بعد. يجب على المسؤول إعداد متغيرات Stripe.'
  },
  schema: {
    fr: 'Les tables ou champs de facturation manquent. L’administrateur doit appliquer la migration SQL de facturation.',
    en: 'Billing tables or fields are missing. An administrator must apply the billing SQL migration.',
    es: 'Faltan tablas o campos de facturación. El administrador debe aplicar la migración SQL.',
    ar: 'جداول أو حقول الفوترة غير موجودة. يجب على المسؤول تطبيق تحديث قاعدة البيانات.'
  },
  config: {
    fr: 'La configuration Stripe est incorrecte : clés, tarifs ou mode test/production à vérifier par l’administrateur.',
    en: 'The Stripe configuration is invalid. An administrator must check keys, prices and test/live mode.',
    es: 'La configuración de Stripe no es válida. El administrador debe revisar claves, precios y modo de prueba/producción.',
    ar: 'إعدادات Stripe غير صحيحة. يجب التحقق من المفاتيح والأسعار ووضع الاختبار أو الإنتاج.'
  },
  existing: {
    fr: 'Un abonnement existe déjà. Utilisez « Gérer mon abonnement » pour le consulter.',
    en: 'A subscription already exists. Use “Manage subscription” to view it.',
    es: 'Ya existe una suscripción. Utiliza «Gestionar suscripción» para consultarla.',
    ar: 'يوجد اشتراك بالفعل. استخدم إدارة الاشتراك للاطلاع عليه.'
  },
  pending: {
    fr: 'Un paiement est déjà en cours de confirmation. Cliquez sur « Actualiser » avant de réessayer.',
    en: 'A payment is already awaiting confirmation. Refresh before retrying.',
    es: 'Ya hay un pago pendiente de confirmación. Actualiza antes de reintentar.',
    ar: 'يوجد دفع بانتظار التأكيد. حدّث الصفحة قبل المحاولة مجدداً.'
  },
  auth: {
    fr: 'Votre session a expiré. Reconnectez-vous avant de payer.',
    en: 'Your session expired. Sign in again before paying.',
    es: 'Tu sesión ha caducado. Inicia sesión antes de pagar.',
    ar: 'انتهت جلستك. سجل الدخول مجدداً قبل الدفع.'
  },
  lifetime: {
    fr: 'Vous bénéficiez déjà de Premium à vie. Aucun paiement nécessaire.',
    en: 'You already have lifetime Premium. No payment is needed.',
    es: 'Ya tienes Premium de por vida. No necesitas pagar.',
    ar: 'لديك Premium مدى الحياة. لا حاجة للدفع.'
  }
};
const additionalLanguages = {
  pt: {
    setup: 'Os pagamentos ainda não estão configurados no servidor. Um administrador deve configurar as variáveis Stripe.',
    schema: 'Faltam tabelas ou campos de faturação. Um administrador deve aplicar a migração SQL de faturação.',
    config: 'A configuração Stripe é inválida. Um administrador deve verificar as chaves, os preços e o modo de teste/produção.',
    existing: 'Já existe uma subscrição. Utilize «Gerir subscrição» para a consultar.',
    pending: 'Já existe um pagamento a aguardar confirmação. Atualize antes de tentar novamente.',
    auth: 'A sua sessão expirou. Inicie sessão novamente antes de pagar.',
    lifetime: 'Já possui Premium vitalício. Não é necessário efetuar qualquer pagamento.'
  },
  zh: {
    setup: '服务器尚未配置付款功能。管理员必须配置 Stripe 变量。', schema: '缺少账单表或字段。管理员必须应用账单 SQL 迁移。',
    config: 'Stripe 配置无效。管理员必须检查密钥、价格以及测试/生产模式。', existing: '订阅已存在。请使用“管理订阅”查看。',
    pending: '已有付款正在等待确认。请刷新后重试。', auth: '您的会话已过期。请重新登录后再付款。', lifetime: '您已拥有终身 Premium，无需付款。'
  },
  de: {
    setup: 'Zahlungen sind auf dem Server noch nicht eingerichtet. Ein Administrator muss die Stripe-Variablen konfigurieren.', schema: 'Abrechnungstabellen oder -felder fehlen. Ein Administrator muss die SQL-Migration für die Abrechnung ausführen.',
    config: 'Die Stripe-Konfiguration ist ungültig. Schlüssel, Preise und Test-/Live-Modus müssen geprüft werden.', existing: 'Es besteht bereits ein Abonnement. Öffnen Sie es über „Abonnement verwalten“.',
    pending: 'Eine Zahlung wartet bereits auf Bestätigung. Aktualisieren Sie die Seite, bevor Sie es erneut versuchen.', auth: 'Ihre Sitzung ist abgelaufen. Melden Sie sich vor der Zahlung erneut an.', lifetime: 'Sie verfügen bereits über lebenslanges Premium. Es ist keine Zahlung erforderlich.'
  },
  ru: {
    setup: 'Платежи на сервере ещё не настроены. Администратор должен настроить переменные Stripe.', schema: 'Отсутствуют таблицы или поля оплаты. Администратор должен применить SQL-миграцию оплаты.',
    config: 'Конфигурация Stripe неверна. Администратор должен проверить ключи, цены и тестовый/рабочий режим.', existing: 'Подписка уже существует. Откройте её через «Управление подпиской».',
    pending: 'Платёж уже ожидает подтверждения. Обновите страницу перед повторной попыткой.', auth: 'Срок действия сеанса истёк. Войдите снова перед оплатой.', lifetime: 'У вас уже есть пожизненный Premium. Оплата не требуется.'
  },
  it: {
    setup: 'I pagamenti non sono ancora configurati sul server. Un amministratore deve configurare le variabili Stripe.', schema: 'Mancano tabelle o campi di fatturazione. Un amministratore deve applicare la migrazione SQL.',
    config: 'La configurazione Stripe non è valida. Un amministratore deve controllare chiavi, prezzi e modalità test/produzione.', existing: 'Esiste già un abbonamento. Usa «Gestisci abbonamento» per consultarlo.',
    pending: 'Un pagamento è già in attesa di conferma. Aggiorna prima di riprovare.', auth: 'La sessione è scaduta. Accedi di nuovo prima di pagare.', lifetime: 'Hai già Premium a vita. Non è necessario alcun pagamento.'
  },
  sr: {
    setup: 'Plaćanja još nisu podešena na serveru. Administrator mora da podesi Stripe promenljive.', schema: 'Nedostaju tabele ili polja za naplatu. Administrator mora da primeni SQL migraciju za naplatu.',
    config: 'Stripe konfiguracija nije ispravna. Administrator mora da proveri ključeve, cene i testni/produkcioni režim.', existing: 'Pretplata već postoji. Otvorite je preko opcije „Upravljaj pretplatom“.',
    pending: 'Plaćanje već čeka potvrdu. Osvežite stranicu pre ponovnog pokušaja.', auth: 'Sesija je istekla. Prijavite se ponovo pre plaćanja.', lifetime: 'Već imate doživotni Premium. Plaćanje nije potrebno.'
  }
};
Object.entries(additionalLanguages).forEach(([language, copy]) => {
  Object.entries(copy).forEach(([group, value]) => { messages[group][language] = value; });
});
export function billingError(code, language = 'fr') {
  const group = ({ BILLING_NOT_CONFIGURED: 'setup', BILLING_SCHEMA_REQUIRED: 'schema',
    BILLING_CREDENTIALS_INVALID: 'config', BILLING_RESOURCE_MISSING: 'config', BILLING_PRICE_MISMATCH: 'config',
    BILLING_PRICE_MUST_BE_EXCLUSIVE: 'config', SUBSCRIPTION_EXISTS: 'existing', PAYMENT_PROCESSING: 'pending',
    LIFETIME_PREMIUM: 'lifetime', TOKEN_REQUIRED: 'auth', ID_USER_REQUIRED: 'auth', TOKEN_INVALID: 'auth' })[code];
  return group ? messages[group][language] || messages[group].fr : null;
}
